
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const SubscriptionStatusCard = () => {
  return (
    <Card className="bg-white shadow-sm border border-gray-200">
      <CardContent className="p-4 lg:p-6">
        <div className="flex justify-between items-start mb-4">
          <div>
            <h2 className="text-lg lg:text-xl font-bold text-gray-900 mb-2">No subscription</h2>
            <p className="text-sm lg:text-base text-gray-600 mb-4">
              Your free trial has expired. To continue using Mayl, upgrade to a paid plan.
            </p>
            <Button className="bg-purple-600 hover:bg-purple-700 text-white">
              Upgrade
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SubscriptionStatusCard;
